import { globalActor } from "../../state/GlobalContextProvider";
import { useSelector } from "@xstate/react";
export default function Sidebar() {
  const showSidebar = useSelector(
    globalActor,
    (snapshot) => snapshot.context.showSidebar
  );

  return (
    <>
      <button
        className="SidebarToggle"
        onClick={(_) => globalActor.send({ type: "TOGGLE_SIDEBAR" })}
      ></button>
      <div className={"Screen Sidebar " + (showSidebar ? "Active" : "")}>
        <button
          className="Toggle"
          onClick={(_) => globalActor.send({ type: "TOGGLE_SIDEBAR" })}
        ></button>
        <div>
          <section>
            <h2>INDICATION</h2>
            <p>
              MIEBO® (perfluorohexyloctane ophthalmic solution) is indicated for
              the treatment of the signs and symptoms of dry eye disease.
            </p>
          </section>
          <section>
            <h2>IMPORTANT SAFETY INFORMATION</h2>
            <ul>
              <li>
                MIEBO is contraindicated in patients with known hypersensitivity
                to perfluorohexyloctane
              </li>
              <li>
                MIEBO should not be administered while wearing contact lenses.
                Contact lenses should be removed before use and for at least 30
                minutes after administration of MIEBO
              </li>
              <li>
                Instruct patients to instill one drop of MIEBO into each eye
                four times daily
              </li>
              <li>
                The safety and efficacy in pediatric patients below the age of
                18 have not been established
              </li>
              <li>
                In pivotal trials, the most common ocular adverse reaction was
                blurred vision (1% to 3% of patients reported blurred vision and
                conjunctival redness)
              </li>
            </ul>
          </section>
          <p>
            Tap{" "}
            <a
              href="https://www.bausch.com/globalassets/pdf/packageinserts/pharma/miebo-package-insert.pdf"
              target="_blank"
              onClick={(_) =>
                window.gaEvent({ event: "prescribe_information_clicked" })
              }
            >
              here
            </a>{" "}
            for full Prescribing Information for MIEBO.
          </p>
          <p>
            You are encouraged to report negative side effects of prescription
            drugs to the FDA. Visit{" "}
            <a href="https://www.fda.gov/medwatch" target="_blank">
              www.fda.gov/medwatch
            </a>{" "}
            or call <a href="tel:1-800-FDA-1088">1-800-FDA-1088</a>.
          </p>
          <section>
            <h2>REFERENCES</h2>
            <ol>
              <li>
                <span>
                  Sheppard JD, Nichols KK. Dry eye disease associated with
                  meibomian gland dysfunction: focus on tear film
                  characteristics and the therapeutic landscape.{" "}
                  <span>Ophthalmol Ther</span>. 2023;12(3):1397-1418.
                  doi:10.1007/s40123-023-00669-1
                </span>
              </li>
              <li>
                <span>
                  Schmidl D, Bata AM, Szegedi S, et al. Influence of
                  perfluorohexyloctane eye drops on tear film thickness in
                  patients with mild to moderate dry eye disease: a randomized
                  controlled clinical trial. <span>J Ocul Pharmacol Ther</span>.
                  2020;36(3):154-161. doi:10.1089/jop.2019.0092
                </span>
              </li>
              <li>
                <span>
                  Agarwal P, Craig JP, Rupenthal ID. Formulation considerations
                  for the management of dry eye disease.{" "}
                  <span>Pharmaceutics</span>. 2021;13(2):207.
                  doi:10.3390/pharmaceutics13020207
                </span>
              </li>
              <li>
                <span>MIEBO. Prescribing Information. Bausch & Lomb, Inc.</span>
              </li>
            </ol>
          </section>
        </div>
      </div>
    </>
  );
}
